/* eslint-disable no-useless-escape */
/* eslint-disable no-eval */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-unused-state */
/* eslint-disable max-len */
import React, { Suspense } from 'react';
import {
    HashRouter,
    Link,
    NavLink,
    Route,
    MemoryRouter,
    Redirect,
    Switch,
} from 'react-router-dom';

import Information from '@appblocks/frontend/client/Components/DeviceDashboard/Information';
import SystemPage from '@appblocks/frontend/client/Components/DeviceDashboard/SystemPage';
import DatabasePage from '@appblocks/frontend/client/Components/DeviceDashboard/Database';
import Settings from '@appblocks/frontend/client/Components/DeviceDashboard/Settings';
import UnoWireSensors from '@appblocks/frontend/client/Components/DeviceDashboard/UnoWireSensors';

import {
    timezones,
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
} from './constants';

import {
    DatetimePicker,
    TimezoneContext,
} from './TimeComponents';

// const Information = React.lazy(() => import(/* webpackChunkName: "Information" */ '@appblocks/frontend/client/Components/DeviceDashboard/Information'));
// const SystemPage = React.lazy(() => import(/* webpackChunkName: "SystemPage" */ '@appblocks/frontend/client/Components/DeviceDashboard/SystemPage'));
// const DatabasePage = React.lazy(() => import(/* webpackChunkName: "Database" */ '@appblocks/frontend/client/Components/DeviceDashboard/Database'));
// const Settings = React.lazy(() => import(/* webpackChunkName: "Settings" */ '@appblocks/frontend/client/Components/DeviceDashboard/Settings'));
const Dashboard = React.lazy(() => import(/* webpackChunkName: "Dashboard" */ '@appblocks/frontend/client/Components/DeviceDashboard/Dashboard'));
// const UnoWireSensors = React.lazy(() => import(/* webpackChunkName: "UnoWireSensors" */ '@appblocks/frontend/client/Components/DeviceDashboard/UnoWireSensors'));


export {
    // eslint-disable-next-line import/prefer-default-export
    DashboardApp,
};

/* FRONTEND_START_MARKER */


class DashboardApp extends React.Component {
    constructor(props) {
        super(props);

        const hashRouter = !props.memoryRouter;

        this.state = {
            showNav: false,
            isPageVisible: true,
            loading: false,
            setupLoading: true,
            widgets: [],
            UNOWIRE_SENSORS: [],
            DASHBOARD_STATE: {
                tablesEnabled: false,
                widgetsEnabled: false,
                title: 'Tibbo Device Dashboard',
            },
            UPDATE_INTERVAL: 1000,
            hashRouter,
        };
        this.getTz = this.getTz.bind(this);
        this.toggleNav = this.toggleNav.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }

    componentDidMount() {
        this.getDashboardSetup();
    }

    componentDidUpdate(prevProps) {
        if (this.props.editPage && !prevProps.connected && this.props.connected) {
            this.getDashboardSetup();
        }
    }

    componentWillUnmount() {

    }

    async getTz() {
        this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.INFORMATION_GET).then((res) => {
            const timezone = res.timezone;
            this.setState({
                timezone,
            });
        });
    }

    async getDashboardSetup() {
        this.setState({
            setupLoading: true,
        }, () => {
            this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.GET_DASHBOARD_SETUP).then((res) => {
                const {
                    widgets,
                    title,
                    settings,
                    unowiresEnabled,
                    unowire_sensors,
                    logEnabled,
                    tablesEnabled,
                    updateInterval,
                    widgetColumns,
                    tables,
                    appName,
                    appVersion,
                } = res;
                const DASHBOARD_STATE = {
                    title,
                    widgetsEnabled: (widgets && widgets.length > 0) || this.props.editPage,
                    settingsEnabled: (settings && settings.length > 0) || this.props.editPage,
                    logEnabled: logEnabled === true,
                    tablesEnabled: tablesEnabled || (tables && tables.find(tbl => tbl.tableStructure === 'T')),
                    unowiresEnabled: unowiresEnabled === true,
                    widgetColumns: widgetColumns || 10,
                    appName,
                    appVersion,
                };
                this.setState({
                    tables,
                    widgets,
                    settings,
                    UPDATE_INTERVAL: updateInterval || 1000,
                    DASHBOARD_STATE,
                    UNOWIRE_SENSORS: unowire_sensors || [],
                }, () => {
                    this.setState({
                        setupLoading: false,
                    });
                });
            });
        });
    }

    toggleNav() {
        this.setState(prevState => ({
            showNav: !prevState.showNav,
        }));
    }

    handleMenuClick(e) {
        // Only close if we're on mobile and the menu is open
        if (window.innerWidth < 768 && this.state.showNav) {
            this.setState({ showNav: false });
        }
    }

    render() {
        if (this.state.loading || this.state.setupLoading) {
            return (
                <div>Loading...</div>
            );
        }
        const { DASHBOARD_STATE } = this.state;
        const layout = (
            <>
                <header className="dashboard-navbar dashboard-font navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
                    <div className="dashboard-navbar-brand navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6">{DASHBOARD_STATE.title}</div>
                    <div className="justify-content-end d-flex align-items-center">
                        <div className="container-fluid">
                            <div className="nav-item">
                                {this.props.connected ? (
                                    <span className="badge rounded-pill bg-success">
                                        Online
                                    </span>
                                ) : (
                                    <span className="badge rounded-pill bg-secondary">
                                        Offline
                                    </span>
                                )}
                            </div>
                        </div>
                        <button
                            className="navbar-toggler collapsed"
                            type="button"
                            onClick={this.toggleNav}
                            aria-controls="sidebarMenu"
                            aria-expanded={this.state.showNav}
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>
                    </div>
                </header>

                <div className="dashboard-container px-0 container-fluid dashboard-font position-relative">
                    <div className="row mx-0 h-100">
                        <nav id="sidebarMenu" className={`col-md-3 col-lg-2 d-md-block sidebar dashboard-sidebar ${this.state.showNav ? 'show' : 'collapse'}`}>
                            <div className="position-sticky pt-3">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <div onClick={this.handleMenuClick}>
                                            <NavLink to="/" className="nav-link" exact activeClassName="active">Home</NavLink>
                                        </div>
                                    </li>
                                    {DASHBOARD_STATE.widgetsEnabled && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink to="/dashboard" className="nav-link" exact activeClassName="active">Dashboard</NavLink>
                                            </div>
                                        </li>
                                    )}
                                    {DASHBOARD_STATE.settingsEnabled && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink to="/settings" className="nav-link" exact activeClassName="active">Settings</NavLink>
                                            </div>
                                        </li>
                                    )}
                                    {(DASHBOARD_STATE.tablesEnabled) && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink
                                                    to="/database"
                                                    className="nav-link"
                                                    exact
                                                    activeClassName="active"
                                                >
                                                    Database
                                                </NavLink>
                                            </div>
                                        </li>
                                    )}
                                    {DASHBOARD_STATE.logEnabled && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink
                                                    to="/log"
                                                    className="nav-link"
                                                    exact
                                                    activeClassName="active"
                                                >
                                                    Log
                                                </NavLink>
                                            </div>
                                        </li>
                                    )}
                                    {DASHBOARD_STATE.unowiresEnabled && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink
                                                    to="/unowiresensors"
                                                    className="nav-link"
                                                    exact
                                                    activeClassName="active"
                                                >
                                                    1-Wire Sensors
                                                </NavLink>
                                            </div>
                                        </li>
                                    )}
                                    {this.props.systemPage && (
                                        <li className="nav-item">
                                            <div onClick={this.handleMenuClick}>
                                                <NavLink
                                                    to="/system"
                                                    className="nav-link"
                                                    exact
                                                    activeClassName="active"
                                                >
                                                    System
                                                </NavLink>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </nav>

                        <main
                            className="col-md-9 ms-sm-auto col-lg-10 px-md-4 pb-5"
                            role="main"
                        >
                            <div
                                className="container-fluid settings-main pt-3"
                                onClick={this.handleMenuClick}
                            >
                                <Suspense fallback={<div>Loading...</div>}>
                                    <TimezoneContext.Provider value={this.props.deviceStatus?.timezone}>
                                        <Switch>
                                            <Route
                                                path="/"
                                                exact
                                                render={() => (
                                                    <Home
                                                        getDeviceState={this.props.getDeviceState}
                                                        deviceStatus={{
                                                            appName: DASHBOARD_STATE.appName,
                                                            appVersion: DASHBOARD_STATE.appVersion,
                                                            ...this.props.deviceStatus,
                                                        }}
                                                        updateTz={() => { this.getTz(); }}
                                                        runCommand={this.props.runCommand}
                                                        key="home"
                                                    />
                                                )}
                                            />
                                            {
                                                DASHBOARD_STATE.widgetsEnabled && (
                                                    <Route
                                                        path="/dashboard"
                                                        render={() => (
                                                            <Dashboard
                                                                widgets={this.state.widgets}
                                                                widgetColumns={DASHBOARD_STATE.widgetColumns}
                                                                UPDATE_INTERVAL={this.state.UPDATE_INTERVAL}
                                                                runCommand={this.props.runCommand}
                                                                editPage={this.props.editPage}
                                                                key="dashboard"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            {
                                                DASHBOARD_STATE.settingsEnabled && (
                                                    <Route
                                                        path="/settings"
                                                        render={() => (
                                                            <Settings
                                                                runCommand={this.props.runCommand}
                                                                settings={this.props.consoleConfig ? this.props.consoleConfig.settings : this.state.settings}
                                                                device={this.props.device}
                                                                editPage={this.props.editPage}
                                                                key="settings"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            {
                                                (DASHBOARD_STATE.tablesEnabled || this.props.editPage !== undefined) && (
                                                    <Route
                                                        path="/database"
                                                        render={() => (
                                                            <DatabasePage
                                                                runCommand={this.props.runCommand}
                                                                tableType="T"
                                                                tables={this.props.consoleConfig ? this.props.consoleConfig.tables : this.state.tables}
                                                                device={this.props.device}
                                                                editPage={this.props.editPage}
                                                                key="database"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            {
                                                DASHBOARD_STATE.logEnabled && (
                                                    <Route
                                                        path="/log"
                                                        render={() => (
                                                            <DatabasePage
                                                                runCommand={this.props.runCommand}
                                                                tableType="L"
                                                                tables={this.state.tables}
                                                                key="log"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            {
                                                DASHBOARD_STATE.unowiresEnabled && (
                                                    <Route
                                                        path="/unowiresensors"
                                                        render={() => (
                                                            <UnoWireSensors
                                                                UNOWIRE_SENSORS={this.state.UNOWIRE_SENSORS}
                                                                runCommand={this.props.runCommand}
                                                                key="unowiresensors"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            {
                                                this.props.systemPage && (
                                                    <Route
                                                        path="/system"
                                                        render={() => (
                                                            <SystemPage
                                                                runCommand={this.props.runCommand}
                                                                firmwareUploadEnabled={DASHBOARD_STATE.firmwareUploadEnabled}
                                                                key="system"
                                                            />
                                                        )}
                                                    />
                                                )
                                            }
                                            <Redirect to="/" />
                                        </Switch>
                                    </TimezoneContext.Provider>
                                </Suspense>
                            </div>
                            {/* <footer style={{
                                position: 'fixed',
                                bottom: 0,
                                padding: 10,
                            }}
                            >
                                <Col>
                                    &copy;
                                    {' '}
                                    {new Date().getFullYear()}
                                    {' '}
                                    Tibbo Technology Inc.
                                </Col>
                                <Col id="actions" />
                            </footer> */}
                        </main>
                    </div>
                </div>
            </>
        );
        if (this.state.hashRouter) {
            return (
                <HashRouter>
                    {layout}
                </HashRouter>
            );
        }
        return (
            <MemoryRouter>
                {
                    this.props.onNextMountNavigateTo && (
                        <Redirect to={this.props.onNextMountNavigateTo} />
                    )
                }
                {layout}
            </MemoryRouter>
        );
    }
}

class Home extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            refreshing: false,
            lastAction: '',
        };

        this.update = this.update.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this.props.getDeviceState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.deviceStatus.lastUpdate !== this.props.deviceStatus.lastUpdate) {
            this.setRefreshed();
        }
    }

    setRefreshed() {
        this.setState({
            refreshing: false,
            lastAction: 'Refreshed',
        });
    }

    refresh() {
        this.setState({
            refreshing: true,
        }, () => {
            this.props.getDeviceState();
        });
    }

    update() {
        this.props.runCommand(
            CMD_SYSTEM, CMD_SYSTEM_ACTION.INFORMATION_GET,
        ).then((res) => {
            this.setState({
                lastAction: 'Updated',
                infos: res,
            });
        });
    }

    render() {
        return (
            <div>
                <h2>Home</h2>
                {this.props.deviceStatus.lastUpdate === undefined
                    ? <div>Loading...</div>
                    : <Information deviceStatus={this.props.deviceStatus} update={this.update} refresh={this.refresh} refreshing={this.state.refreshing} lastAction={this.state.lastAction} runCommand={this.props.runCommand} />
                }
            </div>
        );
    }
}
